import { render } from "./TourLocation.vue?vue&type=template&id=4d1218e3"
import script from "./TourLocation.vue?vue&type=script&lang=js"
export * from "./TourLocation.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "4d1218e3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4d1218e3', script)) {
    api.reload('4d1218e3', script)
  }
  
  module.hot.accept("./TourLocation.vue?vue&type=template&id=4d1218e3", () => {
    api.rerender('4d1218e3', render)
  })

}

script.__file = "resources/js/Pages/Tour/Partials/CreateTourFormParts/TourLocation.vue"

export default script